module.exports = __webpack_public_path__ + "img/select-uppercase.a33bd964.svg";